import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StudentServiceListsService } from '../service/student-service-lists.service';
import { PartyServiceInfo,SSDP_COMPONENT } from '../model/party-service-info';



@Component({
  selector: 'app-service-info',
  templateUrl: './service-info.component.html',
  styleUrl: './service-info.component.scss'
})
export class ServiceInfoComponent {
  responseData: PartyServiceInfo | null = null; // To store the API response data
  ssdpComponents: SSDP_COMPONENT[] = []; // To store the SSDP components
  loading: boolean = false; // To indicate loading state
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private studentService:StudentServiceListsService
  ) { 
    
    this.connectAPI(data.party_service_Id);
    console.log('Service Info Dialog Data:', data); // Debugging line to check incoming data
  }
  connectAPI(partyServiceId: number) {
    this.studentService.getServiceInfoReportByPartyService(partyServiceId).subscribe({
      next: (response:PartyServiceInfo) => {
        this.responseData = response;
         this.loading = true; // Set loading to false after receiving the response
        // Handle the response and update the component state as needed
      },
      error: (error:any) => {
        this.loading = false; // Set loading to false in case of error
        console.error('API Error:', error); // Debugging line to check for errors
        // Handle the error as needed
      }
    });
  }
}
